export default `
  lastWorkflowLog {
    id
    createdAt
    fromStatus {
      ...workflowStatusParts
    }
    toStatus {
      ...workflowStatusParts
    }
    attendancePlace {
      ...attendancePlaceParts
    }
  }
  currentWorkflowStatus {
    ...workflowStatusParts
  }
  permittedWorkflowStatuses {
    ...workflowStatusParts
  }
`;
